export default "__VITE_ASSET__DpXRfAwq__"